import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuGruposUsuarios/pagesGruposDeUsuario/modalNovoGrupoUser.css'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdGrupoUsuario: '',
    IdEmpresa: user[0].IdEmpresa,
    gruDescricao: '',
    gruObservacoes: '',
    gruStatus: 1,
    gruCriadoPor: user[0].pesEmail,
    gruCriadoEm: newDate,
    gruAlteradoPor: user[0].pesEmail,
    gruAlteradoEm: newDate,
    gruCodigoGUID: uuidv4
  })
  function handleInputChange(event) {
    campos[event.target.name] = event.target.value
    setCampos(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/grupousuario', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Novo Grupo
      </button>

      {modal && (
        <div className="modalEquipe">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Novo Grupo de Usuários
                <hr className="hrTitleModal" />
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <label>Novo Grupo:</label>
              <input
                type="text"
                id="fname"
                name="gruDescricao"
                onChange={handleInputChange}
              ></input>

              <label>Observações:</label>
              <textarea
                type="text"
                id="fname"
                name="gruObservacoes"
                onChange={handleInputChange}
                row="none"
                maxLength="500"
              ></textarea>

              <div className="caixaSalvarPadrao">
                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
